import React, { useMemo } from 'react';
import type { ITimeZone } from '@dealroadshow/uikit-date-time';
import cn from 'classnames';
import { getFiltersByKeysWithValues } from '@framework/ui/Organisms/Filters/helpers';
import SharedSidebar from '@/creditflowresearch/ui/common/components/Sidebar/Sidebar';
import { IInitialFilters } from '@/creditflowresearch/domain/vo/Bondscreener/IInitialFilters';
import sidebarStyles from '@framework/ui/Organisms/Filters/FiltersPanel/sidebar.module.scss';
import { IAppliedFilters } from '@/creditflowresearch/domain/vo/Bondscreener/IAppliedFilters';

export interface IFinsightSidebar<T = IAppliedFilters, D = IInitialFilters> {
  filters: T,
  dateFromMin: number,
  FooterContainer: React.ElementType,
  TagsContainer: React.ElementType,
  filtersKeys: readonly string[],
  SectionsContainer: React.ElementType,
  DatePeriodContainer: React.ElementType,
  getFiltersInitialState: () => D,
  onFilterApply: (location:Location) => void,
  resetFilters: (location:Location) => void,
  isFetching: boolean,
  appliedFilters: T | {},
  dateBoundsZone?: ITimeZone,
}

const FinsightSidebar = <
  T extends object = IAppliedFilters,
  D extends object = IInitialFilters,
>(props: IFinsightSidebar<T, D>) => {
  const {
    FooterContainer,
    TagsContainer,
    filtersKeys,
    SectionsContainer,
    DatePeriodContainer,
    filters,
    dateFromMin,
  } = props;
  const isEmptyFilter = !Object.keys(getFiltersByKeysWithValues({
    filtersState: filters,
    // @ts-ignore
    filtersKeys,
    dateFromMin,
  })).length;

  const Footer = useMemo(() => React.forwardRef((props: any, ref) => (
    <FooterContainer
      ref={ ref }
      { ...props }
      className={ cn(props.className, { [sidebarStyles.emptyFooterTags]: isEmptyFilter }) }
      isEmpty={ isEmptyFilter }
    />
  )), [FooterContainer, isEmptyFilter]);

  return (
    <SharedSidebar
      { ...props }
      FooterComponent={ Footer }
      DatePeriodComponent={ DatePeriodContainer }
      SectionsComponent={ SectionsContainer }
      TagsComponent={ TagsContainer }
    />
  );
};

export default FinsightSidebar;
